module.exports = __webpack_public_path__ + "img/jifen.f8be31a7.jpg";